module.exports = __webpack_public_path__ + "static/media/garoon_icon.7700a9e0.png";